import { Link, Outlet } from 'react-router-dom';

import MenuInfo from 'data/menu';
import { useTranslation } from 'react-i18next';
import usePermission from 'hooks/usePermission';

export default function MonitoringSettingLayout() {
    const { t } = useTranslation();
    const setting = MenuInfo.CMMS_MANAGEMENT;

    const { hasPermission } = usePermission();
    const visibleMenus = setting.children.filter(menu => {
        const permissionOk =
            !menu.permission || hasPermission(menu.permission);

        const featureOk =
            menu.feature === undefined || menu.feature;

        return permissionOk && featureOk;
    });
    // console.log(visibleMenus)
    return (
        <>
            <div className="mrosetup_sub">
                <ul>
                    {
                        visibleMenus.map(child => {
                            // console.log(child)
                            return (
                    <li key={child.id}>
                        <Link to={child.fullpath}>
                            {
                                child.isActive
                                ? (<b>{t(child.name)}</b>) 
                                : t(child.name)
                            }
                        </Link>
                    </li>
                            );
                        })
                    }
                </ul>
            </div>

            <div className="main_container main_container1">
                <Outlet/>
            </div>
        </>
    );
}